'use strict';

angular.module('app.entity.audit')
    .component('auditList', {
        templateUrl: 'modules/ecrd/components/audit/components/audit-list.template.html',
        bindings: {
            data: '<',
            fold: '<',
        },
        controller: ['EcrdService', 'CrdConfigurationService', function(EcrdService, CrdConfigurationService) {
            var vm = this;

            // Control en front de elementos expandidos
            vm.expandedElements = {};

            vm.showReason = CrdConfigurationService.getAudit().hasReason();

            vm.$onInit = function() {
                // Si no se especifican aparecen desplegados
                var foldItems = vm.fold || false;

                vm.expandedElements = vm.data.reduce(function(acc, row, index) {
                    acc[index] = !foldItems;

                    return acc;
                }, {});
            };

            vm.toggleElement = function(index) {
                vm.expandedElements[index] = !vm.expandedElements[index];
            };
        }],
    });
